<template>
  <div id="repository-tags-base" class="flex">
    <div
      id="repository-tag-tabs"
      class="sticky top-18 left-0 z-40 w-60 flex-shrink-0 bg-pure-white border-r border-slate-400 overflow-y-auto"
      :style="{ height: 'calc(100vh - 4.5rem)' }"
    >
      <div
        class="sticky top-0 z-10 h-24 px-6 flex items-center bg-pure-white border-b border-slate-400"
      >
        <BlTextTitle3 text="Tags" />
      </div>
      <div class="flex flex-col gap-1 px-3 py-1">
        <div v-for="(tab, idx) in tabs" :key="idx">
          <div v-if="tab.divider" class="h-0.5 w-full bg-slate-300"></div>
          <router-link
            v-else
            :to="tab.target"
            class="relative h-12 px-3 flex items-center gap-2 rounded transition-all duration-300"
            :class="[tab.isActive ? 'bg-slate-300' : 'hover:bg-hover-state']"
          >
            <BlIcon :icon="tab.icon" color="slate-6" class="h-4 w-4" />
            <BlTextSubtitle3 :text="tab.label" />
          </router-link>
        </div>
      </div>
    </div>

    <div id="repository-tag-body" class="flex flex-col flex-grow">
      <div v-if="!currentUser.role.includes('admin')" class="h-14 w-full px-6">
        <div
          class="sticky top-18 z-10 px-4 py-2 bg-info-100 rounded-b flex items-center gap-2"
          :style="{ width: 'calc(100vw - 15rem - 3rem - 0.5rem)' }"
        >
          <div
            class="h-10 w-10 grid place-items-center flex-shrink-0"
            :style="{ background: '#E4F1FA', borderRadius: '0.25rem' }"
          >
            <BlIcon icon="toast-info" class="h-6 w-6" />
          </div>
          <BlTextBody1
            class="text-info"
            text="Please note that adding or editing the tags is restricted to the admin role."
          />
        </div>
      </div>

      <BranchTags v-if="searchParams['tab'] === 'branch'" />
      <ClientTags v-if="!searchParams['tab']" />
      <ProspectTags v-if="searchParams['tab'] === 'prospect'" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import BranchTags from "./tags/BranchTags.vue";
import ClientTags from "./tags/ClientTags.vue";
import ProspectTags from "./tags/ProspectTags.vue";

import BlTextTitle3 from "../BlTextTitle3.vue";
import BlTextSubtitle3 from "../BlTextSubtitle3.vue";
import BlTextBody1 from "../BlTextBody1.vue";
import BlTextBody2 from "../BlTextBody2.vue";
import BlIcon from "../BlIcon.vue";

export default {
  name: "RepositoryTags",
  components: {
    BranchTags,
    ClientTags,
    ProspectTags,
    BlTextTitle3,
    BlTextSubtitle3,
    BlTextBody1,
    BlTextBody2,
    BlIcon
  },
  data() {
    return {
      activeTab: "client-tags"
    };
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter"]),
    enableSalesPipeline() {
      return this.currentCenter.enable_sales_pipeline;
    },
    enableBranch() {
      return this.currentCenter.enable_branch;
    },
    searchParams() {
      return this.$route.query || {};
    },
    tabs() {
      const branch = {
        target: "/repository?tab=branch",
        isActive: this.searchParams["tab"] === "branch",
        icon: "location",
        label: "Branch"
      };
      const prospect = {
        target: "/repository?tab=prospect",
        isActive: this.searchParams["tab"] === "prospect",
        icon: "user-square",
        label: "Prospect"
      };
      return [
        ...(this.enableBranch ? [branch] : []),
        {
          target: "/repository",
          isActive: !this.searchParams["tab"],
          icon: "user-square",
          label: "Client"
        },
        ...(this.enableSalesPipeline && this.currentUser.role.includes("admin")
          ? [prospect]
          : [])
      ];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/repository/Tags.vue